import { DiscountType } from "@omni/types/api/product/bff/shared/enums/discountType.enum";
import { Promotion } from "@omni/types/api/product/bff/shared/promotion.model";
import { CloudPromotion } from "@omni/types/api/product/cloud/shared/promotion";
import { AlgoliaSearchPromotion } from "@omni/types/api/search/algolia/product/shared/promotion.model";
import { BffSearchPromotion } from "@omni/types/api/search/bff/product/shared/promotion.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { PromotionTypeMapper } from "./enums/promotionType.enumMapper";

const getDiscountType = (
    promotionValue?: number | null,
    promotionPercent?: number | null
): DiscountType | null => {
    if (promotionValue) return DiscountType.Absolute;
    if (promotionPercent) return DiscountType.Percentage;

    return null;
};

const fromCloudToBff: ModelMapper<CloudPromotion, Promotion> = (model) => {
    const discountType = getDiscountType(
        model.promotionValue,
        model.promotionPercent
    );

    const promotionType = PromotionTypeMapper.fromCloudToBff(
        model.promotionType
    );

    return {
        promotionCode: model.promotionCode,
        promotionType: promotionType,
        promotionValue: model.promotionValue,
        promotionPercent: model.promotionPercent,
        marketingText: model.marketingText,
        // TODO: Date time conversion?
        validFrom: model.validFrom,
        // TODO: Date time conversion?
        validTo: model.validTo,
        periodText: model.periodText,
        discountType: discountType
    } satisfies Promotion;
};

const fromAlgoliaSearchToBff: ModelMapper<AlgoliaSearchPromotion, Promotion> = (
    model
) => {
    const discountType = getDiscountType(
        model.promotionValue,
        model.promotionPercentage
    );

    const promotionType = PromotionTypeMapper.fromAlgoliaSearchToBff(
        model.promotionType
    );

    return {
        promotionCode: null,
        promotionType: promotionType,
        promotionValue: model.promotionValue,
        promotionPercent: model.promotionPercentage,
        marketingText: undefined,
        validFrom: model.validFrom,
        validTo: model.validTo,
        periodText: model.periodText,
        discountType: discountType
    } satisfies Promotion;
};

const fromAlgoliaSearchToBffSearch: ModelMapper<
    AlgoliaSearchPromotion,
    BffSearchPromotion
> = (model) => {
    const promotionType = PromotionTypeMapper.fromAlgoliaSearchToBffSearch(
        model.promotionType
    );

    return {
        promotionType: promotionType,
        promotionValue: model.promotionValue,
        promotionPercentage: model.promotionPercentage,
        validFrom: model.validFrom,
        validTo: model.validTo,
        periodText: model.periodText
    } satisfies BffSearchPromotion;
};

const fromBffSearchToBff: ModelMapper<BffSearchPromotion, Promotion> = (
    model
) => {
    const discountType = getDiscountType(
        model.promotionValue,
        model.promotionPercentage
    );

    const promotionType = PromotionTypeMapper.fromBffSearchToBff(
        model.promotionType
    );

    return {
        promotionCode: null,
        promotionType: promotionType,
        promotionValue: model.promotionValue,
        promotionPercent: model.promotionPercentage,
        marketingText: undefined,
        validFrom: model.validFrom,
        validTo: model.validTo,
        periodText: model.periodText,
        discountType: discountType
    } satisfies Promotion;
};

const fromBffSearchToAlgoliaSearch: ModelMapper<
    BffSearchPromotion,
    AlgoliaSearchPromotion
> = (model) => {
    const promotionType = PromotionTypeMapper.fromBffSearchToAlgoliaSearch(
        model.promotionType
    );

    return {
        promotionType: promotionType,
        promotionValue: model.promotionValue,
        promotionPercentage: model.promotionPercentage,
        validFrom: model.validFrom,
        validTo: model.validTo,
        periodText: model.periodText
    } satisfies AlgoliaSearchPromotion;
};

const fromBffToAlgoliaSearch: ModelMapper<Promotion, AlgoliaSearchPromotion> = (
    model
) => {
    const promotionType = PromotionTypeMapper.fromBffToAlgoliaSearch(
        model.promotionType
    );

    return {
        promotionValue: model.promotionValue,
        promotionType: promotionType,
        promotionPercentage: model.promotionPercent,
        validFrom: model.validFrom,
        validTo: model.validTo,
        periodText: model.periodText
    } satisfies AlgoliaSearchPromotion;
};

const fromBffToBffSearch: ModelMapper<Promotion, BffSearchPromotion> = (
    model
) => {
    const promotionType = PromotionTypeMapper.fromBffToBffSearch(
        model.promotionType
    );

    return {
        promotionValue: model.promotionValue,
        promotionType: promotionType,
        promotionPercentage: model.promotionPercent,
        validFrom: model.validFrom,
        validTo: model.validTo,
        periodText: model.periodText
    } satisfies BffSearchPromotion;
};

export const PromotionMapper = {
    fromCloudToBff: fromCloudToBff,
    fromAlgoliaSearchToBff: fromAlgoliaSearchToBff,
    fromAlgoliaSearchToBffSearch: fromAlgoliaSearchToBffSearch,
    fromBffSearchToBff: fromBffSearchToBff,
    fromBffSearchToAlgoliaSearch: fromBffSearchToAlgoliaSearch,
    fromBffToAlgoliaSearch: fromBffToAlgoliaSearch,
    fromBffToBffSearch: fromBffToBffSearch
};
